export default __webpack_public_path__ + "static/media/appointment.31057794.png";